import { Typography, Link } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { formatDateTime } from "../../utils/DateTimeUtils";

const CustomerCallLogsForModule = (props: any) => {
  const columns: GridColDef[] = [
    { field: "id", headerName: "ID"},
    {
      field: "from",
      headerName: "From",
      renderCell: (cellValues) => {
        return (
          <div>
            {
                cellValues?.row?.admin?.name
            }
          </div>
        );
      },
    },
    {
      field: "to",
      headerName: "To",
      renderCell: (cellValues) => {
        return (
          <div>
            {
                [cellValues?.row?.user?.fname, cellValues?.row?.user?.lname].filter(Boolean).join(' ') || cellValues?.row?.to
            }
          </div>
        );
      },
      minWidth: 180,
    },
    {
        field: "status",
        headerName: "Status",
      },
    {
      field: "duration",
      headerName: "Duration",
      renderCell: (cellValues) => {
        return (
          <div>
            {
                Math.floor((cellValues?.row?.duration) / 60) !== 0 ?
                    Math.floor((cellValues?.row?.duration) / 60) + " min " + ((cellValues?.row?.duration) % 60)+" sec" :
                    ((cellValues?.row?.duration) % 60)+" sec"
            }
          </div>
        );
      },
    },
    {
      field: "callStartTime",
      headerName: "Call start Time",
      renderCell: (cellValues) => {
        return <div>{formatDateTime(cellValues?.row?.callStartTime) || "-"}</div>
      },
      minWidth: 170,
    },
    {
        field: "callEndTime",
        headerName: "Call end Time",
        renderCell: (cellValues) => {
          return <div>{formatDateTime(cellValues?.row?.callEndTime) || "-"}</div>
        },
        minWidth: 170,
    },
    {
        field: "referenceId",
        headerName: "Reference Id",
        minWidth: 130,

        renderCell: (cellValues) => {
    const data = cellValues.row;

    const route =
      data?.referenceModelName === "ONE_MEAL_SERVICE"
        ? "OneMealService"
        : "ChefForParty";

    const href = `/#/${route}/${data?.referenceId}/show`;
    return (
      <Typography>
        <Link href={href} >
          {data?.referenceId}
        </Link>
      </Typography>
    );
  },
    },
    {
        field: "referenceModelName",
        headerName: "Reference Modal",
        renderCell: (cellValues) => {
          return <div>{cellValues?.row?.referenceModelName}</div>
        },
        minWidth: 170,
    },
    {
        field: "purpose",
        headerName: "Purpose",
        renderCell: (cellValues) => {
          return <div>{cellValues?.row?.purpose}</div>
        },
    },
    {
      field: "action",
      headerName: "Action",
      renderCell: (cellValues) => {
        return (
            <audio src={cellValues?.row?.recordingUrl} controls></audio>
        )
      },
      minWidth: 200,
    },
  ];
  return (
    <div style={{ height: '100vh', width: "100%", marginBottom: "40px" }}>
      <DataGrid
        columns={columns}
        rows={props?.data ?? []}
        pageSize={props?.pageSize}
        onPageSizeChange={(pageSize) => {
          props.setPageSize(pageSize);
        }}
        loading={props?.isLoading}
        rowsPerPageOptions={[5, 10, 25, 50]}
        rowCount={props?.count ?? 0}
        paginationMode = "server"
        onPageChange={(page) => {
          props.refreshData(page);
        }}
        disableSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        experimentalFeatures={{ newEditingApi: true }}
      />
    </div>
  );
};

export default CustomerCallLogsForModule;
